import DataType from '@opsbase/lib-datatype/DataType';
import i18n from '@opsbase/lib-i18n';
import Language from '@opsbase/lib-i18n/Language';
import Palette from '@opsbase/lib-palette';
import useSelf from '@opsbase/react-ctrl-self/useSelf';
import useSelfLanguage from '@opsbase/react-ctrl-self/useSelf/useSelfLanguage';
import useKeywordSearch from '@opsbase/react-gql-hooks/keyword/useKeywordSearch';
import useOpDefinitionPlaces from '@opsbase/react-gql-hooks/opdefinition/useOpDefinitionPlaces';
import useCss from '@opsbase/web-css';
import OpDefinitionChooser from '@opsbase/web-data-choosers/OpDefinitionChooser';
import OpDefPlaceChooser from '@opsbase/web-data-choosers/OpDefPlaceChooser';
import Dialog from '@opsbase/web-dialogs/Dialog';
import DialogSize from '@opsbase/web-dialogs/Dialog/DialogSize';
import Pane from '@opsbase/web-layout/Pane';
import Vertical from '@opsbase/web-layout/Vertical';
import useNav from '@opsbase/web-nav/useNav';
import DateTimePicker from '@opsbase/web-pickers/DatePicker/DateTimePicker';
import TextFieldWithStateAndBlur from '@opsbase/web-textfield/TextFieldWithStateAndBlur';
import Button from '@opsbase/web-ui/Button';
import Dots from '@opsbase/web-ui/Dots';
import PickerItem from '@opsbase/web-ui/PickerItem';
import Text from '@opsbase/web-ui/Text';
import moment from 'moment-timezone';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
const makeMyClasses = () => ({
    placePane: {
        borderRadius: 4,
        border: `1px solid ${Palette.LavendarGrey.main}`,
    },
});
export function OpPerformStartDialog(props) {
    var _a, _b, _c, _d;
    const { loading, op, onStart, ondemand = false } = props;
    const { goBack } = useNav();
    const { language } = useSelfLanguage();
    const self = useSelf();
    const [opDefinitionId, setOpDefinitionId] = useState();
    const [placeId, setPlaceId] = useState();
    const [title, setTitle] = useState();
    const [completeBy, setCompleteBy] = useState(moment().startOf('hour').add(2, 'hour'));
    const { loading: loadingOnDemands, data: onDemandData } = useKeywordSearch({
        variables: {
            type: [DataType.OPDEFINITION],
            permitAdhoc: ['TRUE'],
            enabled: ['TRUE'],
            showMineOnly: self.isPrimary || self.isAdmin ? null : ['TRUE'],
            showWebAppOnly: ['TRUE'],
        },
    });
    const onDemands = useMemo(() => {
        var _a, _b;
        return (_b = (_a = (onDemandData || [])
            .find(v => v.type === DataType.OPDEFINITION)) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.map(i => {
            var _a;
            return ({
                ...i,
                title: language !== Language.ENGLISH ? ((_a = i.titleAlt) === null || _a === void 0 ? void 0 : _a[language]) || i.title : i.title,
                type: DataType.OPDEFINITION,
            });
        });
    }, [onDemandData, language]);
    const [opDefinition, setOpDefinition] = useState();
    const [chosenPlace, setChosenPlace] = useState([]);
    const myCss = useCss(makeMyClasses);
    const doSetChosenPlace = useMemo(() => v => {
        var _a;
        setChosenPlace(v);
        setPlaceId((_a = v === null || v === void 0 ? void 0 : v[0]) === null || _a === void 0 ? void 0 : _a.id);
    }, []);
    useEffect(() => {
        if (op) {
            setOpDefinitionId(op === null || op === void 0 ? void 0 : op.opDefinitionId);
            doSetChosenPlace([op === null || op === void 0 ? void 0 : op.place]);
            setTitle(op === null || op === void 0 ? void 0 : op.title);
            setCompleteBy(op === null || op === void 0 ? void 0 : op.completeBy);
        }
    }, [doSetChosenPlace, op]);
    const { loading: placesLoading, data: allowedPlaces } = useOpDefinitionPlaces({
        variables: { id: opDefinitionId, showMineOnly: true },
        skip: !opDefinitionId,
    });
    useEffect(() => {
        if ((allowedPlaces === null || allowedPlaces === void 0 ? void 0 : allowedPlaces.length) === 1)
            doSetChosenPlace(allowedPlaces);
    }, [allowedPlaces, doSetChosenPlace]);
    const handleCancel = useCallback(() => goBack(), [goBack]);
    const handleStart = useCallback(() => {
        onStart(opDefinitionId, placeId, title, completeBy.toDate());
    }, [completeBy, onStart, opDefinitionId, placeId, title]);
    const handleChangeOpDefinition = useCallback(v => {
        var _a, _b;
        setOpDefinition(v);
        setOpDefinitionId((_a = v === null || v === void 0 ? void 0 : v[0]) === null || _a === void 0 ? void 0 : _a.id);
        setTitle((_b = v === null || v === void 0 ? void 0 : v[0]) === null || _b === void 0 ? void 0 : _b.title);
    }, []);
    const handleChangePlace = useCallback(v => doSetChosenPlace(v), [doSetChosenPlace]);
    const handleChangeTitle = useCallback(v => setTitle(v), []);
    const handleChangeCompleteBy = useCallback(v => setCompleteBy(v), []);
    const canStart = !!op || (opDefinitionId && placeId);
    return (React.createElement(Dialog, { size: DialogSize.X450_Y350, closable: false, title: i18n.t('start-an-op'), loading: loading, buttonsLeft: React.createElement(Button, { color: Palette.Grey, label: i18n.t('cancel'), onClick: handleCancel }), buttonsRight: React.createElement(Button, { disabled: !canStart, color: Palette.positive, label: i18n.t('start-op'), onClick: handleStart }) },
        !loadingOnDemands && !(onDemands === null || onDemands === void 0 ? void 0 : onDemands.length) && React.createElement(Text, null, i18n.t('no-on-demand')),
        React.createElement(Vertical, { padding: true, gutter: true },
            loadingOnDemands && (React.createElement(Dots, { style: { margin: '32px auto' }, color: Palette.primary })),
            !op && !loadingOnDemands && (onDemands === null || onDemands === void 0 ? void 0 : onDemands.length) && (React.createElement(OpDefinitionChooser, { value: opDefinition, items: onDemands, onChange: handleChangeOpDefinition })),
            !op && !!opDefinitionId && (allowedPlaces === null || allowedPlaces === void 0 ? void 0 : allowedPlaces.length) > 1 && (React.createElement(OpDefPlaceChooser, { value: chosenPlace, onChange: handleChangePlace, placesList: allowedPlaces, opDefinition: opDefinitionId })),
            !op && !!opDefinitionId && (allowedPlaces === null || allowedPlaces === void 0 ? void 0 : allowedPlaces.length) === 1 && (React.createElement(Pane, { classes: { root: myCss.placePane } },
                React.createElement(PickerItem, { type: DataType.PLACE, title: (_a = allowedPlaces[0]) === null || _a === void 0 ? void 0 : _a.title }))),
            !op && !!opDefinitionId && !placesLoading && (allowedPlaces === null || allowedPlaces === void 0 ? void 0 : allowedPlaces.length) === 0 && (React.createElement(Pane, null,
                React.createElement(Text, { color: "error" }, i18n.t('unable-to-work-in-places')))),
            !!op && (React.createElement(Pane, { classes: { root: myCss.placePane } },
                React.createElement(PickerItem, { type: DataType.OPDEFINITION, title: op === null || op === void 0 ? void 0 : op.title }))),
            !!op && (React.createElement(Pane, { classes: { root: myCss.placePane } },
                React.createElement(PickerItem, { type: DataType.PLACE, title: (_b = op === null || op === void 0 ? void 0 : op.place) === null || _b === void 0 ? void 0 : _b.title }))),
            !!canStart && (React.createElement(TextFieldWithStateAndBlur, { value: title, white: true, onBlur: handleChangeTitle, label: i18n.t('title') })),
            !!canStart && (React.createElement(Pane, null,
                React.createElement(Text, { variant: "h2" }, "Due"),
                React.createElement(DateTimePicker
                // timezone={chosenPlace?.[0]?.timezone || 'UTC'}
                , { 
                    // timezone={chosenPlace?.[0]?.timezone || 'UTC'}
                    noMargin: true, disabled: !ondemand, value: completeBy, onChange: handleChangeCompleteBy, white: ondemand ? true : false }),
                React.createElement(Text, { tip: `I.e. ${(_c = chosenPlace === null || chosenPlace === void 0 ? void 0 : chosenPlace[0]) === null || _c === void 0 ? void 0 : _c.timezone}`, variant: "small" },
                    "Due date timezone is ", (_d = chosenPlace === null || chosenPlace === void 0 ? void 0 : chosenPlace[0]) === null || _d === void 0 ? void 0 :
                    _d.title))))));
}
export default OpPerformStartDialog;
